import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';
import { FolderKanban, ArrowRight, Target } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function ActiveProjectCard() {
  // TODO: Replace with actual project data
  const project = {
    name: 'Task Manager Application',
    progress: 35,
    nextMilestone: 'Implement user authentication',
    estimatedCompletion: '2 weeks'
  };

  return (
    <Card accent className="bg-card shadow-md border-border hover:shadow-lg transition-shadow">
      <CardHeader>
        <CardTitle className="text-lg font-bold text-primary flex items-center gap-2">
          <div className="p-1.5 rounded-md bg-primary/10">
            <FolderKanban className="h-5 w-5 text-primary" />
          </div>
          Active Project
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <div className="flex items-center justify-between mb-2">
            <p className="font-bold text-foreground">{project.name}</p>
            <Badge variant="branch-secondary" className="text-xs">{project.progress}%</Badge>
          </div>
          <Progress value={project.progress} className="h-2" />
        </div>
        
        <div className="p-4 rounded-lg bg-secondary/5 border-l-4 border-secondary shadow-sm">
          <div className="flex items-start gap-2 mb-2">
            <Target className="h-4 w-4 text-secondary mt-0.5" />
            <p className="text-xs font-bold text-secondary uppercase tracking-wide">
              Next Milestone
            </p>
          </div>
          <p className="text-sm font-medium text-foreground">{project.nextMilestone}</p>
          <p className="text-xs text-muted-foreground mt-2">
            Est. completion: <span className="font-semibold">{project.estimatedCompletion}</span>
          </p>
        </div>

        <Button variant="outline" className="w-full hover:bg-primary/10 hover:border-primary hover:text-primary transition-colors" asChild>
          <Link to="/projects">
            View Project Board <ArrowRight className="ml-2 h-4 w-4" />
          </Link>
        </Button>
      </CardContent>
    </Card>
  );
}
